<div
  class="search-by-account-manager-component"
  data-automation-e2e-selector="searchAccountManager"
>
  <cupcake-suggester
    [suggesterGroupHeaderTemplate]="customGroupHeaderTemplate"
    [suggesterGroupField]="'type'"
    [suggesterMultiselectMode]="false"
    [suggesterWaitMs]="100"
    [suggesterOptionsLimit]="(accountManagerList | async)?.length"
    [suggesterDataSource]="accountManagerList | async"
    [suggesterPreLoadDataSource]="accountManagerList | async"
    [suggesterValueField]="'name'"
    [suggesterIdField]="'id'"
    [suggesterDisabledField]="'disabled'"
    [suggesterFilterMode]="false"
    suggesterPlaceholder="Managers/Accounts"
    (suggesterOnSelectEvent)="suggesterOnSelect($event)"
  >
    <ng-template #customGroupHeaderTemplate let-model="item">
      <span class="suggester-header"
        >{{ model.item.value + 's' | lowercase }}</span
      >
    </ng-template>
  </cupcake-suggester>
</div>
